import type { IconName } from "@/components/Icon";

/**
 * Work-item type — the shared discriminator on every task row. `task` is the
 * generic default; `story` and `bug` are the agile affordances. Epics are a
 * separate entity, not a task type.
 */
export type WorkItemType = "task" | "story" | "bug";

export const WORK_ITEM_TYPES: WorkItemType[] = ["task", "story", "bug"];

type TypeMeta = { label: string; icon: IconName; color: string };

// Colours double as text (type chips/labels) so they use AA-contrast ink
// shades, not the brighter base hues.
const META: Record<WorkItemType, TypeMeta> = {
  task: { label: "Task", icon: "check", color: "var(--st-todo-ink, #2563a8)" },
  story: { label: "Story", icon: "board", color: "#157049" },
  bug: { label: "Bug", icon: "flag", color: "#b91c1c" },
};

export function typeMeta(type: WorkItemType | null | undefined): TypeMeta {
  return META[type ?? "task"] ?? META.task;
}

export function typeLabel(type: WorkItemType | null | undefined): string {
  return typeMeta(type).label;
}
